import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  editViolationFailed,
  editViolationSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL_V2,
} from '../../../configs';

export default function* editViolation(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL_V2}/dict/violations/${action.payload.id}`;
    const response = yield makeRequest(url, action.payload, action, 'PUT', true);
    if (response.status === OK) {
      yield put(editViolationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(editViolationFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editViolationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
